import {FC} from 'react'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Có gì đó sai sai</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Vui lòng tải lại trang!
      </div>
    </>
  )
}

export {Error500}
